export const CITY_LIST = 'CITY_LIST'
export const OWNARD_TICKET_DATA = 'OWNARD_TICKET_DATA'
export const COUNTRY_LIST = 'COUNTRY_LIST'
export const BRANCHES_LIST = 'BRANCHES_LIST'
export const PAYMENT_MODA_LIST = 'PAYMENT_MODA_LIST'
export const BUS_LIST = "BUS_LIST";
export const TRIP_SHEET_TABLE_DATA = "TRIP_SHEET_TABLE_DATA";
export const TRIP_LIST_ALL = 'TRIP_LIST_ALL'
export const UPDATE_ONWARD_BLOCK = 'UPDATE_ONWARD_BLOCK'
export const UPDATE_BLOCKSEAT_LIST = 'UPDATE_BLOCKSEAT_LIST'
export const UPDATE_TICKET_NUMBER = 'UPDATE_TICKET_NUMBER'
export const CAN_REQ_LIST = 'CAN_REQ_LIST'
export const OWNARD_CURRENT_TICKET_DATA = 'OWNARD_CURRENT_TICKET_DATA'
export const UPDATE_STOCK_COUNTER = 'UPDATE_STOCK_COUNTER'
export const UPDATE_ADVOWARD_DISCOUNT = 'UPDATE_ADVOWARD_DISCOUNT'
export const UPDATE_ADVORETURN_DISCOUNT = 'UPDATE_ADVORETURN_DISCOUNT'
export const UPDATE_CURROWARD_DISCOUNT = 'UPDATE_CURROWARD_DISCOUNT'
export const UPDATE_CURRRETURN_DISCOUNT = 'UPDATE_CURRRETURN_DISCOUNT'
export const UPDATE_CLASS_TYPE_LIST = 'UPDATE_CLASS_TYPE_LIST'
export const UPDATE_STARTING_FROM = 'UPDATE_STARTING_FROM'
export const UPDATE_ACCO_TYPE = 'UPDATE_ACCO_TYPE'
export const UPDATE_VARIANT_DATA = 'UPDATE_VARIANT_DATA'
export const KSTDC_CITY_LIST = 'KSTDC_CITY_LIST'
export const UPDATE_ID_TYPE_LIST = 'UPDATE_ID_TYPE_LIST'
export const MANIFEST_DETAILS = 'MANIFEST_DETAILS'
export const CARGO_VEHICLE_DETAILS = 'CARGO_VEHICLE_DETAILS'
export const DRIVER_CONDUCTOR_LIST_ALL = 'DRIVER_CONDUCTOR_LIST_ALL'
export const CARGO_DISATCH = 'CARGO_DISATCH'
export const ISSUE_CARGO_PPR = 'ISSUE_CARGO_PPR'
export const ISSUE_CARGO_BALANCE = 'ISSUE_CARGO_BALANCE'
